let interfaceToast = {
  "loginTimeout": "Logon timeout please log in again",
  "interfaceError": "Error code \"&&\", please contact your system administrator",
  "networkError": "Internet connection failed, please try again later",
}
export default interfaceToast;



// WEBPACK FOOTER //
// ./src/i18n/interfaceToast-en.js